@if (currentStep === 'RequestToken') {
  <ng-container [formGroup]="resetPasswordRequestFormGroup">
    <app-h4>Reset your password</app-h4>
    <form (ngSubmit)="requestResetPassword()" tid="request-reset-password-form">
      <app-input
        tid="username"
        type="email"
        [emailField]="true"
        formPropertyName="email"
        label="Email"
        placeholder="Email"
        appAutoFocus
      ></app-input>
      <div class="form-actions">
        <app-button
          theme="secondary-action"
          (click)="cancel()"
          [buttonWidth]="'full'"
          bypassLoadingRequirement
          [fontColor]="'primary-v2'"
          [uppercaseText]="false"
        >
          Back
        </app-button>
        <app-button
          theme="primary-v2"
          type="submit"
          [loading]="inFlight$ | async"
          tid="submit-button"
          [buttonWidth]="'full'"
          [fontColor]="'white'"
          [uppercaseText]="false"
          bypassLoadingRequirement
        >
          Continue
        </app-button>
      </div>
    </form>
  </ng-container>
}

@if (currentStep === 'CompleteResetPassword') {
  <ng-container [formGroup]="resetPasswordFormGroup">
    <form (ngSubmit)="completeResetPassword()" tid="complete-reset-password-form">
      <app-password-reset-controls #passwordResetControls></app-password-reset-controls>
      <div class="form-actions">
        <app-button
          theme="secondary-action"
          (click)="cancel()"
          [buttonWidth]="'full'"
          [fontColor]="'primary-v2'"
          [uppercaseText]="false"
          bypassLoadingRequirement
        >
          Back
        </app-button>
        <app-button
          theme="primary-v2"
          type="submit"
          [loading]="inFlight$ | async"
          tid="submit-button"
          [buttonWidth]="'full'"
          [fontColor]="'white'"
          [uppercaseText]="false"
        >
          Create Password
        </app-button>
      </div>
    </form>
  </ng-container>
}
